/**
 * WhatsAppButton - Floating call + WhatsApp action buttons.
 *
 * i18n (Phase 5):
 *   - Uses whatsapp.* namespace (callAria, whatsappAria, defaultMessage).
 *   - The phone number, the WhatsApp number, and the wa.me URL itself are
 *     intentionally hardcoded business contact constants.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MessageCircle, Phone } from 'lucide-react';

export const WhatsAppButton = () => {
  const { t } = useTranslation();
  const phoneNumber = '33766301503';
  const message = t('whatsapp.defaultMessage');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3" data-testid="floating-buttons">
      {/* Call Button */}
      <a
        href="tel:0939242320"
        className="w-14 h-14 bg-graphite-700 border border-graphite-500 hover:bg-graphite-600 hover:border-graphite-400 rounded-2xl flex items-center justify-center shadow-large transition-all hover:scale-105"
        aria-label={t('whatsapp.callAria')}
        data-testid="call-button"
      >
        <Phone className="w-6 h-6 text-white" />
      </a>

      {/* WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-[#25D366] hover:bg-[#20BD5C] rounded-2xl flex items-center justify-center shadow-large transition-all hover:scale-105"
        aria-label={t('whatsapp.whatsappAria')}
        data-testid="whatsapp-button"
      >
        <MessageCircle className="w-6 h-6 text-white" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
